enum TagStyle {
  SOLID = 'solid',
  OUTLINE = 'outline',
}
enum TagWidth {
  FIT_CONTENT = 'fit-content',
  FULL_WIDTH = 'full-width',
}
export { TagStyle, TagWidth };
